module.exports = __webpack_public_path__ + "static/institutovertere-5770e0c267f0fc5ce2d6aafcf3d65697.svg";